import React, { useState, useEffect } from "react";
import { baseUrl } from '../../shared.js';
import '../App.css';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { Toggle } from '../../components/ui';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import Autocomplete from '@mui/material/Autocomplete';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from "@mui/x-date-pickers";
import moment from 'moment';
  
function Edit({foundAsset, onCancel}) {
  const [changed, setChanged] = useState(false);
  const [assetEdit] = useState(foundAsset);
  const [modAsset, setModAsset] = useState(foundAsset);
  var [assetTypes, setAssetTypes] = useState([]);
  const [assetTypesLoaded, setAssetTypesLoaded] = useState(false);
  var [companies, setCompanies] = useState([]);
  const [companiesLoaded, setCompaniesLoaded] = useState(false);
  var [capacities, setCapacities] = useState([]);
  const [capacitiesLoaded, setCapacitiesLoaded] = useState(false);
  var [descriptions, setDescriptions] = useState([]);
  const [descriptionsLoaded, setDescriptionsLoaded] = useState(false);
  var [makes, setMakes] = useState([]);
  const [makesLoaded, setMakesLoaded] = useState(false);
  var [maxHeights, setMaxHeights] = useState([]);
  const [maxHeightsLoaded, setMaxHeightsLoaded] = useState(false);
  var [models, setModels] = useState([]);
  const [modelsLoaded, setModelsLoaded] = useState(false);
  var [siteLocations, setSiteLocations] = useState([]);
  const [siteLocationsLoaded, setSiteLocationsLoaded] = useState(false);
  var [companyAcId, setCompanyAcId] = useState();
  var [modifiedCatKey, setModifiedCatKey] = useState();



useEffect(()=> {
  console.log(changed);
  console.log('Edit Asset ',assetEdit);
  console.log('Mod Asset ',modAsset);
});

const [open, setOpen] = React.useState(false);
const [responseOpen, setResponseOpen] = React.useState(false);
const [message, setMessage] = useState('');


const handleResponseClose = () => {
setResponseOpen(false);
window.location.href='/?assetNo='+[modAsset.assetId]
};


    const handleClickOpen = () => {
      setOpen(true);
    };

  const handleClose = () => {
    setOpen(false);
  };

async function updateAsset(e) {
  e.preventDefault();
  const url = baseUrl+'id/'+ [assetEdit.id];
  await fetch(url, {
      method: 'PATCH',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken'),
          'editType': 'Update'
      },
      body: JSON.stringify(modAsset),
  })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data.status === 200) {
          setMessage(data.message);
          setResponseOpen(true);
          } else if (data.status === 401) {
            setMessage(data.message);
            setResponseOpen(true);
          }
        })
        .catch((err) => {
          setMessage(err.message);
          setResponseOpen(true);
        });
}

async function deleteAsset(e) {
  e.preventDefault();
  const url = baseUrl+'id/'+ [assetEdit.id];
  await fetch(url, {
      method: 'DELETE',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
  })
      .then((data) => {
        window.location.href='/'
      });
}

const loadAssetTypes = async () => {
    const url = baseUrl + 'asset/typeAc/';
      await fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        }})
        .then((res) => {
          return res.json();
      }).then((json) => {
          setAssetTypes(json);
          console.log('Types Loaded ', assetTypes)
      })
      .catch((err) => {
        setAssetTypesLoaded(false);
         console.log(err.message);
      });
    }

const loadCompanies = async () => {
    const url = baseUrl + 'company/listAc/';
      await fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        }})
        .then((res) => {
          return res.json();
      }).then((json) => {
          console.log('companies ',json)
          setCompanies(json);
          setCompanyAcId(`${Math.floor((Math.random() * 1000))}-min`);
          console.log('companies named ',companies)
      })
      .catch((err) => {
        setCompaniesLoaded(false);
         console.log(err.message);
      });
    }

const loadCapacities = async () => {
      const url = baseUrl + 'asset/capacityAc/';
        await fetch(url, {
          method: 'GET',
          headers: {
              'username': localStorage.getItem('username'),
              'bToken': localStorage.getItem('bToken')
          }})
          .then((res) => {
            return res.json();
        }).then((json) => {
            console.log(json)
            setCapacities(json);
        })
        .catch((err) => {
          setCapacitiesLoaded(false);
           console.log(err.message);
        });
      }

const loadDescriptions = async () => {
        const url = baseUrl + 'asset/descriptionAc/';
          await fetch(url, {
            method: 'GET',
            headers: {
                'username': localStorage.getItem('username'),
                'bToken': localStorage.getItem('bToken')
            }})
            .then((res) => {
              return res.json();
          }).then((json) => {
              console.log(json)
              setDescriptions(json);
          })
          .catch((err) => {
            setDescriptionsLoaded(false);
             console.log(err.message);
          });
        }

const loadMakes = async () => {
          const url = baseUrl + 'asset/makeAc/';
            await fetch(url, {
              method: 'GET',
              headers: {
                  'username': localStorage.getItem('username'),
                  'bToken': localStorage.getItem('bToken')
              }})
              .then((res) => {
                return res.json();
            }).then((json) => {
                console.log(json)
                setMakes(json);
            })
            .catch((err) => {
              setMakesLoaded(false);
               console.log(err.message);
            });
          }

const loadMaxHeights = async () => {
            const url = baseUrl + 'asset/maxHeightAc/';
              await fetch(url, {
                method: 'GET',
                headers: {
                    'username': localStorage.getItem('username'),
                    'bToken': localStorage.getItem('bToken')
                }})
                .then((res) => {
                  return res.json();
              }).then((json) => {
                  console.log(json)
                  setMaxHeights(json);
              })
              .catch((err) => {
                setMaxHeightsLoaded(false);
                 console.log(err.message);
              });
            }

const loadSiteLocations = async () => {
              const url = baseUrl + 'asset/siteLocationAc/';
                await fetch(url, {
                  method: 'GET',
                  headers: {
                      'username': localStorage.getItem('username'),
                      'bToken': localStorage.getItem('bToken')
                  }})
                  .then((res) => {
                    return res.json();
                }).then((json) => {
                    console.log(json)
                    setSiteLocations(json);
                })
                .catch((err) => {
                  setSiteLocationsLoaded(false);
                   console.log(err.message);
                });
              }

const loadModels = async () => {
              const url = baseUrl + 'asset/modelAc/';
                await fetch(url, {
                  method: 'GET',
                  headers: {
                      'username': localStorage.getItem('username'),
                      'bToken': localStorage.getItem('bToken')
                  }})
                  .then((res) => {
                    return res.json();
                }).then((json) => {
                    console.log(json)
                    setModels(json);
                })
                .catch((err) => {
                  setModelsLoaded(false);
                   console.log(err.message);
                });
              }
          
useEffect(() => {
  if (!assetTypesLoaded ) {
    setAssetTypesLoaded(true)
    loadAssetTypes()
  }
  if (!companiesLoaded ) {
    setCompaniesLoaded(true)
    loadCompanies()
  }
  if (!capacitiesLoaded ) {
    setCapacitiesLoaded(true)
    loadCapacities()
  }
  if (!descriptionsLoaded ) {
    setDescriptionsLoaded(true)
    loadDescriptions()
  }
  if (!makesLoaded ) {
    setMakesLoaded(true)
    loadMakes()
  }
  if (!maxHeightsLoaded ) {
    setMaxHeightsLoaded(true)
    loadMaxHeights()
  }
  if (!siteLocationsLoaded ) {
    setSiteLocationsLoaded(true)
    loadSiteLocations()
  }
  if (!modelsLoaded ) {
    setModelsLoaded(true)
    loadModels()
  }
})

return (
    <div>
      <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="confirmDeleteTitle">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmDeleteDesc">
            Are you sure you want to delete the Asset?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={deleteAsset}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
      <React.Fragment>
      <Dialog
        open={responseOpen}
        onClose={handleResponseClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="confirmResponseTitle">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmResponseDesc">
            [{message}]
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResponseClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

        <Box sx={{ display: 'flex', flexDirection: 'column', maxHeight: '82vh' }}>
     {/* Pinned header */}
     <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, py: 1.5, borderBottom: '1px solid var(--border)', background: 'var(--surface)' }}>
       <Typography variant="h6" sx={{ fontWeight: 700 }}>Edit Asset</Typography>
       {localStorage.getItem('canDeleteAsset') === '1' && (
         <Tooltip title="Delete asset">
           <IconButton onClick={handleClickOpen} sx={{ color: 'var(--fail)' }} aria-label="delete asset">
             <DeleteIcon />
           </IconButton>
         </Tooltip>
       )}
     </Box>
     {/* Scrollable fields */}
     <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 2 }}>
     <Box
          margin="dense">
         <TextField
        fullWidth
          margin="dense"
          id="catNo"
          label="Catalogue Number"
          variant="outlined" 
          type="text" 
          InputProps={{
            readOnly: true,
          }}
          value={modAsset.catNo} 
          onChange={(e) => {
            setChanged(true);
            setModAsset({
               ...modAsset,
            catNo: e.target.value,
            modifiedCat: 1,
            });
            setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
            }}
        />
     </Box>
        <Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="assetId" 
          label="Asset Number" 
          variant="outlined" 
          type="text" 
          value={modAsset.assetId} 
          onChange={(e) => {
            setChanged(true);
            setModAsset({
               ...modAsset,
            assetId: e.target.value,
            modifiedCat: 1,
            });
            setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
            }}
        />
     </Box>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  id={companyAcId}
  options={companies}
  defaultValue={modAsset.customer}
  onChange={(e) => {
    setChanged(true);
    setModAsset({
       ...modAsset,
    customer: e.target.innerHTML,
    modifiedCat: 1,
    });
    setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Customer" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  id="typeAc"
  options={assetTypes}
  defaultValue={modAsset.type}
  onChange={(e) => {
    setChanged(true);
    setModAsset({
       ...modAsset,
    type: e.target.innerHTML,
    modifiedCat: 1,
    });
    setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Type" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  id="siteLocationAc"
  options={siteLocations}
  defaultValue={modAsset.siteLocation}
  onChange={(e) => {
    setChanged(true);
    setModAsset({
       ...modAsset,
    siteLocation: e.target.innerHTML,
    modifiedCat: 1,
    });
    setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Site Location" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  options={descriptions}
  defaultValue={modAsset.item}
  onChange={(e) => {
    setChanged(true);
    setModAsset({
       ...modAsset,
    item: e.target.innerHTML,
    modifiedCat: 1,
    });
    setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Item" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  options={makes}
  defaultValue={modAsset.manufacturer}
  onChange={(e) => {
    setChanged(true);
    setModAsset({
       ...modAsset,
    manufacturer: e.target.innerHTML,
    modifiedCat: 1,
    });
    setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Manufacturer" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  options={models}
  defaultValue={modAsset.model}
  onChange={(e) => {
    setChanged(true);
    setModAsset({
       ...modAsset,
    model: e.target.innerHTML,
    modifiedCat: 1,
    });
    setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Model" />}
    />
  </FormControl>
     <Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="serialNo" 
          label="Serial Number" 
          variant="outlined" 
          type="text" 
          value={modAsset.serialNo} 
          onChange={(e) => {
            setChanged(true);
            setModAsset({
               ...modAsset,
            serialNo: e.target.value,
            modifiedCat: 1,
            });
            setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
            }}
        />
     </Box>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  options={maxHeights}
  defaultValue={modAsset.maxHeight}
  onChange={(e) => {
    setChanged(true);
    setModAsset({
       ...modAsset,
    maxHeight: e.target.innerHTML,
    modifiedCat: 1,
    });
    setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Max Height" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  id="typeAc"
  options={capacities}
  defaultValue={modAsset.capacity}
  onChange={(e) => {
    setChanged(true);
    setModAsset({
       ...modAsset,
    capacity: e.target.innerHTML,
    modifiedCat: 1,
    });
    setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Capacity" />}
    />
  </FormControl>
      <LocalizationProvider dateAdapter={AdapterMoment}>
     <MobileDatePicker 
        slotProps={{ textField: { fullWidth: true } }}
        sx={{ mt: 1, mb: 1 }}
        margin="dense"
        id="buildDate" 
        label="Build Date"
        variant="outlined" 
        format="DD-MM-YYYY"
        defaultValue={moment(modAsset.buildDate)}
        onChange={(e) => {
          console.log('here',e)
          setChanged(true);
          setModAsset({
             ...modAsset,
          buildDate: (moment(e).format('YYYY-MM-DD') === 'Invalid date' ) ? '-' : moment(e).format('YYYY-MM-DD'),
          modifiedCat: 1,
          });
          setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
        }}
      />
     <MobileDatePicker 
        slotProps={{ textField: { fullWidth: true } }}
        sx={{ mt: 1, mb: 1 }}
        margin="dense"
        id="expiringCalibrationDate" 
        label="Calibration Expiry Date"
        variant="outlined" 
        format="DD-MM-YYYY"
        defaultValue={moment(modAsset.expiringCalibrationDate)}
        onChange={(e) => {
          setChanged(true);
          setModAsset({
             ...modAsset,
          expiringCalibrationDate: (moment(e).format('YYYY-MM-DD') === 'Invalid date' ) ? '-' : moment(e).format('YYYY-MM-DD'),
          modifiedCat: 1,
          });
          setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
        }}
      />
     </LocalizationProvider>
     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 1 }}>
       <Typography variant="body2" sx={{ fontWeight: 600 }}>New Asset Setup</Typography>
       <Toggle
         checked={Number(modAsset.newCat) === 1}
         onChange={() => {
           setChanged(true);
           setModAsset({ ...modAsset, newCat: Number(modAsset.newCat) === 1 ? 0 : 1, modifiedCat: 1 });
           setModifiedCatKey(`${Math.floor((Math.random() * 1000))}-min`);
         }}
       />
     </Box>
     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 1 }}>
       <Typography variant="body2" sx={{ fontWeight: 600 }}>Asset Changed</Typography>
       <Toggle
         checked={Number(modAsset.modifiedCat) === 1}
         onChange={() => {
           setChanged(true);
           setModAsset({ ...modAsset, modifiedCat: Number(modAsset.modifiedCat) === 1 ? 0 : 1 });
         }}
       />
     </Box>
     
 </Box>{/* end scrollable fields */}
 {/* Pinned solid footer */}
 <Box
   sx={{
     flexShrink: 0,
     display: 'flex',
     justifyContent: 'space-between',
     alignItems: 'center',
     gap: 1.5,
     px: 3,
     py: 1.5,
     background: 'var(--surface)',
     borderTop: '1px solid var(--border)',
   }}
 >
   <Button variant="outlined" color="inherit"
       sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }}
       onClick={(e) => {
           if (onCancel) { onCancel(); } else { window.location.href='/?assetNo='+[modAsset.assetId]; }
       }}
   >
       Cancel
   </Button>
   <form id="asset" onClick={updateAsset} style={{ margin: 0 }}>
       <Button variant="contained" disabled={!changed} form="asset">
           Save Changes
       </Button>
   </form>
 </Box>
        </Box>
  </div>
)};
                              
export default Edit